<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button type="gradient" class="w-full mb-4" color="#7367F0" gradient-color-secondary="#CE9FFC"
                    @click="popupAddPacote = true">Adicionar novo pacote</vs-button>



                <vs-popup class="holamundo" title="Adiconar pacote" :active.sync="popupAddPacote">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Nome</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="nome" />
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Preço</label>
                            <vs-input class="w-full mt-2 mb-5" type="number" v-model="preco"/>
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Descrição</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="descricao"/>
                        </div>

                        <div class="vx-col w-full mb-2">
                            <div class="flex flex-wrap items-center flex-start">
                                <vs-button class="ml-auto mt-2" :disabled="nome=='' || preco=='' || descricao==''" @click="savePackage">Salvar</vs-button>
                                <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button> -->
                            </div>

                        </div>
                    </div>
                </vs-popup>

                <vs-popup class="holamundo" title="Actualizar Pacote" :active.sync="popupOpenEditPacote">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Nome</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="nome" />
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Preço</label>
                            <vs-input class="w-full mt-2 mb-5" type="number" v-model="preco"/>
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Descrição</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="descricao"/>
                        </div>

                        <div class="vx-col w-full mb-2">
                            <div class="flex flex-wrap items-center flex-start">
                                <vs-button class="ml-auto mt-2" :disabled="nome=='' || preco=='' || descricao==''" @click="savePackage">Salvar</vs-button>
                                <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button> -->
                            </div>

                        </div>
                    </div>
                </vs-popup>
                <vs-popup class="holamundo" title="Módulos" :active.sync="popupModulo">
                  <!-- {{ pacoteSelected }} -->
                  <vx-input-group class="mb-base">
               <v-select
                 label="name"
                  :options="modulos"
                  v-model="selectedModule"
                name="name"
              />
                <template slot="append">
                   <div class="append-text btn-addon">
          <vs-button color="primary" @click="addModule"><i class="fa fa-plus"></i> Modulo</vs-button>
        </div>
                </template>
              </vx-input-group>
                        <vs-table :data="pacoteSelected.modules">



<template slot="thead">
  <vs-th sort-key="name">Nome</vs-th>
  <vs-th sort-key="name">Decricao</vs-th>
  <vs-th></vs-th>
</template>

<template slot-scope="{data}">
  <vs-tr v-for="modulo in pacoteSelected.modules" :key="id">
 

    <vs-td >
        {{modulo.name}}
    </vs-td>

    <vs-td >
      {{modulo.description}}
    </vs-td>

    <vs-td class="whitespace-no-wrap" >

      <vs-button color="danger" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-trash"
      >Remover</vs-button>

    </vs-td>

  </vs-tr>
</template>
</vs-table >
<vs-popup class="holamundo" title="Adiconar pacote" :active.sync="popupAddModulo">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Nome</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="nomeModulo" />
                        </div>
                      
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Descrição</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="descricaoModulo"/>
                        </div>

                        <div class="vx-col w-full mb-2">
                            <div class="flex flex-wrap items-center flex-start">
                                <vs-button class="ml-auto mt-2" :disabled="nomeModulo=='' || descricaoModulo==''" @click="savePackage">Salvar</vs-button>
                                <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button> -->
                            </div>

                        </div>
                    </div>
                </vs-popup>
                </vs-popup>
               
            </div>

          
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" :key="id" v-for="pacote in pacotes">
                <vx-card>
                    
                      <div class="flex flex-wrap items-center justify-end">
                        <vs-dropdown>
                        <feather-icon icon="MoreHorizontalIcon" svgClasses="w-6 h-6"></feather-icon>
                            <vs-dropdown-menu>

                                <vs-dropdown-item>
                                   Editar
                                </vs-dropdown-item >

                                <vs-dropdown-item divider>
                                   Remover
                                </vs-dropdown-item>

                              
                            </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>
                  
                   
                       
                    <div class="py-4 rounded-lg bg-primary text-center">
                        <h3 class="text-white">{{pacote.name}}</h3>
                        
                    </div>
                    <div class="my-6 text-center">
                        <h1 class="mb-2">{{ pacote.price }}MT/Mês</h1>
                        <p class="text-grey">{{ pacote.description }}</p>
                    </div>
                    <vs-divider></vs-divider>
                    <!-- v-for="modulo in modulos" :key="id" -->
                    <div class="my-6 text-center" >
                      <div  v-for="mod in pacote.modules" :key="id">
                        <span class="flex mr-6">
                            <feather-icon class="cursor-pointer" icon="CheckCircleIcon"
                                svgClasses="text-success stroke-current h-6 w-6" />
                            <span class="ml-2">{{ mod.name}}</span>
                            
                        </span>
                        <vs-divider></vs-divider>
                        </div>
                       
                    </div>
                        <vs-button type="gradient" class="w-full mt-6" color="#7367F0"
                            gradient-color-secondary="#CE9FFC" @click="popupOpenModulo(pacote)">Módulos</vs-button>
                      
                </vx-card>
            </div>
          











            <!-- CONTENT CARD - ICONS -->


        </div>


    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { videoPlayer } from 'vue-video-player'
import VxTimeline from "@/components/timeline/VxTimeline.vue"
import 'video.js/dist/video-js.css'
import http from '../../../../http-common'
import vSelect from 'vue-select'


export default {
    components:{
        vSelect
    },
    data() {
        return {
            popupAddPacote: false,
            nome:"",
            preco:"",
            descricao:"",
            pacotes:[],
            popupAddModulo:false,
            popupOpenEditPacote:false,
            popupModulo:false,

            nomeModulo:"",
            descricaoModulo:"",
            modulos:[],
            pacoteSelected:[],
            selectedModule:[],
        }
    },

    mounted() {
        this.getData();
        this.getModules();
    },
    created() {

    },
    methods: {
       async savePackage() {
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        name: this.nome,
        description: this.descricao,
        price: this.preco,
        


      };

      this.$validator.validateAll();
      await http
        .post("/admin/packages", data, config)
        .then((success) => {
          success;
          this.popupAddPacote = false,
            this.nome = "",
            this.descricao = "",
            this.preco = "",
          

            this.getData(),
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            console.log(this.err)
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          }

        });
    },
    getData() {
    //   this.$vs.loading({
    //     container: '#div-with-loading',
    //     scale: 1.0,
    //     type: 'sound'
    //   })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       

      };

      http
        .get("/admin/packages", config)
        .then((result) => {
        //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.pacotes = result.data
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    getModules() {
    //   this.$vs.loading({
    //     container: '#div-with-loading',
    //     scale: 1.0,
    //     type: 'sound'
    //   })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       

      };

      http
        .get("/admin/modules", config)
        .then((result) => {
        //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.modulos = result.data
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    popupOpenModulo(pacote){
      this.pacoteSelected=pacote
      this.popupModulo =true
    },
    async addModule() {
     
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };


      const data = {
        module_id:[this.selectedModule.id]
        


      };

      this.$validator.validateAll();
      await http
        .post(`/admin/packages/add-modules/${this.pacoteSelected.id}`, data, config)
        .then((success) => {
          success;
          this.popupModulo = false
            this.getData(),
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            console.log(this.err)
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          }

        });
    },
    },
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}</style>
